import WebApiService from "@/services/webapi.service.js";
import Contratto from "@/models/Contratto.model.js";


const state = {
    contratti:[]
}

const getters = {

    getContratti: (state) => {      
        return state.contratti;
    }
}

const mutations = {
    setContratti: (state, contratti) => {
        state.contratti = contratti;
    }
}

const actions = {

    getContratti: ({commit}, data) => {
        return WebApiService.get('contratti/GetContratti', data.token).then(
            (data) => {
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }else{
                    commit("setEntita", data.Data.map(
                        o => { return Object.assign(new Contratto(),o) }
                    ));
                    return [true, ""];
                }
            },
            error => {
                return [false,""];
            }
        )
        .catch(
            error => {return [false, ""]}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}